import { createContext, useContext } from "react";
import type { DevConsoleMsg, DevConsoleState } from "./devConsole";
import type { LiveMsg } from "./live";
import type {
  BackendRequest,
  RewardCenterMsg,
  RewardCenterState,
} from "./rewardCenter/types";
import type { System } from "./system";

type Actors = {
  rewardCenter: RewardCenterMsg;
  backend: BackendRequest;
  live: LiveMsg;
  devConsole: DevConsoleMsg;
};

type RewardCenterContextValue = {
  state: RewardCenterState;
  devConsole: DevConsoleState;
  send: System<Actors>["send"];
};

const RewardCenterContext = createContext<RewardCenterContextValue | null>(
  null,
);

const useRewardCenter = () => {
  const context = useContext(RewardCenterContext);
  if (!context) {
    throw new Error("useRewardCenter must be used inside RewardCenterProvider");
  }
  return context;
};

export default useRewardCenter;
export type { Actors };
export { RewardCenterContext };
